import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'react-bootstrap';
import ViewScenarioStatusContainer
  from './../Containers/ViewScenarioStatusContainer';

const CaseMetricsDispatcherComponent = ({
  onJumpToClick,
  jumpDestination
}) => {

  return (
    <div>
      <fieldset>
        <legend>
          Additional Options
        </legend>
      </fieldset>
      <Col sm={3}>
        <Button
          id="button-jump"
          bsSize="small"
          onClick={() => onJumpToClick()}
        >
          Jump to {jumpDestination}
        </Button>
      </Col>
      <ViewScenarioStatusContainer />
    </div>
  );
};

CaseMetricsDispatcherComponent.propTypes = {
  onJumpToClick: PropTypes.func.isRequired,
  jumpDestination: PropTypes.string.isRequired
};

export default CaseMetricsDispatcherComponent;


// WEBPACK FOOTER //
// src/Components/CaseMetricsDispatcherComponent.jsx